import { Button, Space, Typography } from '@arco-design/web-react';
import contactAdminIllustration from 'jukun-ui-standard/dist-css/assets/states/enterprise/state-contact-admin.webp';
import maintenanceIllustration from 'jukun-ui-standard/dist-css/assets/states/enterprise/state-maintenance.webp';
import noPermissionIllustration from 'jukun-ui-standard/dist-css/assets/states/enterprise/state-no-permission.webp';

export type PortalStateVariant = 'no-permission' | 'maintenance' | 'system-error';

const stateContent: Record<PortalStateVariant, {
  illustration: string;
  title: string;
  description: string;
}> = {
  'no-permission': {
    illustration: noPermissionIllustration,
    title: '暂无访问权限',
    description: '当前账号尚未获得该应用的访问权限，请联系管理员完成授权。',
  },
  maintenance: {
    illustration: maintenanceIllustration,
    title: '系统维护中',
    description: '当前应用正在维护，请稍后再试。',
  },
  'system-error': {
    illustration: contactAdminIllustration,
    title: '系统异常',
    description: '应用状态异常或加载失败，请联系管理员。',
  },
};

export function PortalStatePage(props: {
  variant: PortalStateVariant;
  mode?: 'block' | 'page';
  onRetry?: () => void;
  onBack?: () => void;
}) {
  const content = stateContent[props.variant];
  return (
    <div className={`ui-state-page ui-state-page--${props.mode ?? 'page'}`}
      role={props.variant === 'system-error' ? 'alert' : 'status'}>
      <img className="ui-state-page__illustration" src={content.illustration} alt="" />
      <h5>{content.title}</h5>
      <Typography.Paragraph type="secondary">{content.description}</Typography.Paragraph>
      {props.onRetry || props.onBack ? <Space>
        {props.onRetry ? <Button type="primary" onClick={props.onRetry}>重新加载</Button> : null}
        {props.onBack ? <Button type={props.onRetry ? 'secondary' : 'primary'}
          onClick={props.onBack}>返回工作台</Button> : null}
      </Space> : null}
    </div>
  );
}
